import { useEffect, useState } from "react";
import { getAnalyticsAIStatus } from "../../../api/analyticsApi";
import StaffReflectionThemes from "./StaffReflectionThemes";

/** Mounted only for the current own-school leader/publication; no generation action exists. */
export default function AnalyticsAINarrative({ organisationId, publicationDay }: { organisationId: string; publicationDay: string }) {
  const [unverified, setUnverified] = useState(false);
  useEffect(() => {
    let current = true;
    setUnverified(false);
    // Never accept analysis or an ON signal from a stale/forged response in this release.
    Promise.resolve().then(() => getAnalyticsAIStatus(organisationId)).then(() => {
      if (current) setUnverified(false);
    }).catch(() => { if (current) setUnverified(true); });
    return () => { current = false; };
  }, [organisationId]);
  return <div className="space-y-5">
    <section aria-labelledby="ai-strengths-title" className="rounded-lg border border-pd-rule bg-pd-white p-5">
      <h2 id="ai-strengths-title" className="font-display text-2xl">Strengths and areas for development</h2>
      <p className="mt-3 text-sm">AI analysis across all programme data</p>
      <p className="mt-2 text-sm font-semibold">To be checked by leaders</p>
      <p className="mt-3 text-sm text-pd-slate">The current numeric report uses published programme figures dated {publicationDay}. No programme data is sent for AI analysis by this release.</p>
      {unverified ? <p className="mt-2 text-sm text-pd-slate">AI availability could not be verified. Analysis remains disabled.</p> : null}
      <label className="mt-4 flex items-start gap-3 text-sm"><input type="checkbox" disabled checked={false} readOnly className="mt-1" />Include AI narrative and themes in governors’ report</label>
      <p className="mt-2 text-xs text-pd-slate">Inclusion is disabled for this release. Numeric reports remain available.</p>
    </section>
    <StaffReflectionThemes />
  </div>;
}
